import type { VisitaVirtualPageModel } from '@/interfaces/model';
import type { VisitaVirtualPage } from '@/interfaces/strapi';
import { mapGalleryFrom, mapStrapiFile } from '@/helpers/strapi-assets-helpers';

export const visitaVirtualMapper = (api: VisitaVirtualPageModel): VisitaVirtualPage => ({
	exterior: mapGalleryFrom(api.exterior),
	acceso: mapGalleryFrom(api.acceso),
	interior1: mapGalleryFrom(api.interior1),
	interior2: mapGalleryFrom(api.interior2),
	dossier: mapStrapiFile(api.dossier),
});
